import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'

const fetchDeleteClaim = async (claimFormId: string) => {
  const response = await httpClientPrivate.delete(
    `${config.restUrl}/v1/backoffice/e-claim/${claimFormId}`,
  )
  return response.data
}

export { fetchDeleteClaim }
